<template>
    <div class="page-panel-main page-home">       
        <div class="main-body">
            <div class="main-body-menu" :class="{'smallMode':smallMode,'normalMode':!smallMode,'BurgerFull':showMnuBurgerFull}">
                <div class="menu" @click.stop.prevent>
                    <div class="menu-logo" @click="ToggleMenu">                        
                        <div class="title">
                            <span><span>San Pedro Pozohuacan</span></span>
                        </div>
                        <div class="pointer bars">                            
                            <i class="pi pi-bars"></i>
                        </div>
                    </div>                
                    <MenuVComponent :go="true" :menus="menus" :smallMode="smallMode" @onClickMenu="showMnuBurgerFull=false">
                    </MenuVComponent>                                     
                    <CloseSesionView :version="version"  v-on:on-close="closeSesion"></CloseSesionView>                                         
                </div> 
            </div>
            <div class="main-body-content" :class="{'smallModeBody':!smallMode,'normalModeBody':smallMode,'BodyHiden':showMnuBurgerFull}">                
                <ToolbarView :sesion="sesion" v-if="sesion && sesion.Gid" @onMenu=onMenu></ToolbarView>
                <div class="container-page scroll-thin-custom">
                    <router-view/> 
                </div> 
                
            </div>
        </div>       
    </div>
</template>
<script  setup lang="ts">
import LoginService from '@/core/services/login/LoginService';
import CloseSesionView from './CloseSesionView.vue';
import MenuVComponent from './MenuVComponent.vue';
import ToolbarView from './ToolbarView.vue';
import { useServicesFactoryStore } from '@/core/stores/services-factory-store';
import { computed, onMounted, ref } from 'vue';
import { ISesionApp, SesionApp } from '@/core/model/sesion/ISesionApp';
import { useRouter } from 'vue-router';
import { eAppPaths, eRolAppUsuario } from '@/core/model/GloblasEnum';
import menus from '@/assets/config/app-menus.json';
import { useMainStore } from '@/core/stores/main-store';
import { jwtDecode } from "jwt-decode";

const router = useRouter();
const loginService:LoginService = useServicesFactoryStore().getLoginService;
const sesion = ref<ISesionApp>(new SesionApp());
const smallMode = ref<boolean>(false);
const showMnuBurgerFull = ref<boolean>(false);
const mainStore = useMainStore();
const version = ref<string>(mainStore.getAppConfig.version);

const closeSesion = async () =>
{
    const type = sesion.value.Type;
    await loginService.CloseSesion();
    if(type === eRolAppUsuario.Empleado)
        router.replace({name:eAppPaths.login});
}
const onMenu = ()=>
{
    smallMode.value = false;
    showMnuBurgerFull.value=true;

}
const ToggleMenu = () =>
{
    smallMode.value = !smallMode.value;
    showMnuBurgerFull.value=false;
}

const ExpirationDate = computed(():Date => 
{
    const decoded = jwtDecode(sesion.value.Token);
    if(decoded.exp)
    {
        
        const utcDate = new Date(decoded.exp * 1000);
        return utcDate;
       /* return new Date(
    utcDate.getUTCFullYear(),
    utcDate.getUTCMonth(),
    utcDate.getUTCDate(),
    utcDate.getUTCHours(),
    utcDate.getUTCMinutes(),
    utcDate.getUTCSeconds(),
    utcDate.getUTCMilliseconds(),
  );   */    
    }
    else
        return new Date();
});
onMounted(async ()=>
{                   
    sesion.value = await loginService.getSession();        
    const hoy = new Date();    
    if(ExpirationDate.value < hoy)
    {
        closeSesion();
    }
    window.scrollTo(0, 0);
});
</script>
<style scoped>

</style>